import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";
import TaiwanReqMain from "./TaiwanReqMain";
const TaiwanReq = () => {
  return (
    <div className="uaeReqContainer">
      <TaiwanReqMain />
    </div>
  );
};

export default TaiwanReq;
